<template>
  <div
    v-resize="onResize"
    :style="{ background: $vuetify.theme.themes[theme].background }"
    style="overflow-y: hidden;"
    class="overflow-visible"
  >
    <v-system-bar
      :height="POPUP_TOP_HEIGHT"
      :color="color"
      style="position: relative;"
    >
      <div>
        <v-btn
          class="pa-2"
          icon
          v-if="icon"
          outlined
          x-large
          :color="color"
          style="background-color: white; z-index: 3; pointer-events: none;"
        >
          <v-icon :color="color" class="ma-0">{{ icon }}</v-icon>
        </v-btn>
        <span class="text-uppercase" style="color: white">{{ title }}</span>
      </div>
      <div style="position: absolute; right: 0;">
        <v-btn
          @click="handleRemoveClick"
          small
          icon
          v-if="boilerplate || this.$listeners.remove"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-btn
          @click="handleFullscreenClick"
          small
          icon
          v-if="boilerplate || storeModal || this.$listeners.fullscreen"
        >
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>
        <v-btn
          small
          @click="handleCloseClick"
          icon
          v-if="boilerplate || storeModal || this.$listeners.close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-system-bar>
    <v-container fluid>
      <div :style="height" class="overflow-y-auto">
        <slot />
      </div>
      <v-row
        justify="end"
        align="center"
        :style="`height: ${POPUP_BOTTOM_HEIGHT}px`"
        :class="{ 'mr-5': boilerplate }"
      >
        <slot name="actions" />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import {
  POPUP_BOTTOM_HEIGHT,
  POPUP_TOP_HEIGHT,
} from '@/components/dialogs/customDialog.styles';
import resizable from '@/business/mixins/resizable';
import { mapGetters } from 'vuex';

export default {
  name: 'custom-dialog',
  mixins: [resizable],
  props: {
    icon: { type: String, required: false },
    title: { type: String, required: false },
    color: { type: String, required: false },
    boilerplate: { type: Boolean, default: false },
    storeModal: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      isStoreModalFullscreen: 'modal/isFullscreen',
      isBoilerplateModalFullscreen: 'boilerplate/isModalFullscreen',
    }),
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    isFullscreen() {
      if (this.storeModal) {
        return this.isStoreModalFullscreen;
      }
      if (this.boilerplate) {
        return this.isBoilerplateModalFullscreen;
      }
      return this.fullscreen;
    },
    height() {
      if (this.boilerplate) {
        const calcHeight =
          this.boilerplatePopupHeight - POPUP_TOP_HEIGHT - POPUP_BOTTOM_HEIGHT;
        if (calcHeight > 0) return `height: ${calcHeight}px`;
      }
      if (this.isFullscreen) {
        const calcHeight =
          this.windowSize.y - POPUP_TOP_HEIGHT - POPUP_BOTTOM_HEIGHT;
        if (calcHeight > 0) return `height: ${calcHeight}px`;
      }
      const calcHeight =
        this.windowSize.y * 0.9 - POPUP_TOP_HEIGHT - POPUP_BOTTOM_HEIGHT;
      if (calcHeight > 0) return `max-height: ${calcHeight}px`;
      return null;
    },
  },
  data() {
    return {
      POPUP_BOTTOM_HEIGHT,
      POPUP_TOP_HEIGHT,
    };
  },
  methods: {
    generateMessage,
    handleCloseClick() {
      this.$emit('close');
      if (this.boilerplate)
        this.$store.dispatch('boilerplate/setModalOpened', { component: null });
      if (this.storeModal) this.$store.dispatch('modal/hideModal');
    },
    handleRemoveClick() {
      this.$emit('remove');
      if (this.boilerplate)
        this.$store.dispatch('boilerplate/setModalOpened', { component: null });
    },
    handleFullscreenClick() {
      this.$emit('fullscreen');
      if (this.boilerplate)
        this.$store.dispatch('boilerplate/toggleModalFullscreen');
      if (this.storeModal) this.$store.dispatch('modal/toggleFullscreen');
    },
  },
};
</script>
